import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { ViewTransitionTypes, viewTransition } from "@/utils/view-transitions";

export const Route = createFileRoute(
	"/_authenticated/(org-app)/_orgAdmin/org-admin/$orgId/settings",
)({
	component: RouteComponent,
	beforeLoad: ({ params, location }) => {
		// Check if we're at the exact settings path (not a child route)
		const settingsPath = `/org-admin/${params.orgId}/settings`;
		if (
			location.pathname === settingsPath ||
			location.pathname === `${settingsPath}/`
		) {
			throw redirect({
				to: "/org-admin/$orgId/settings/preferences",
				params: {
					orgId: params.orgId,
				},
				replace: true,
				...viewTransition(ViewTransitionTypes.FADE),
			});
		}
	},
});

function RouteComponent() {
	return <Outlet />;
}
